import { useIntl } from 'react-intl';
import useAuthorization from '@alltrails/context/hooks/useAuthorization';
import { updateTrack } from '@alltrails/tracks';
import { ButtonConfig } from '../../hooks/useAdminCTAs';
import { AdminMapHit, AdminTrackHit } from './utils';

/**
 * This component currently only implements a subset of the functionality from the monolith.
 * See the method below for implementation of missing links:
 * https://github.com/alltrails/alltrails/blob/a00887a87114a5dd6a3fe0b2b6cb35db81eef537/app/javascript/application/javascripts/react_components/mixins/map/map_mixin.js#L647
 */

const useAdminTrackLinks = (track?: AdminTrackHit | AdminMapHit) => {
  const intl = useIntl();
  const { hasPermission } = useAuthorization();
  const isAdmin = hasPermission({ permission: 'trails:manage' });
  const isPLP = hasPermission({ permission: 'public_lands:manage' });

  if (!isAdmin && !isPLP) {
    return;
  }

  if (!track) {
    return;
  }

  const linksConfig: ButtonConfig[] = [];
  if (isAdmin) {
    linksConfig.push({
      label: intl.formatMessage({ defaultMessage: 'Hide' }),
      id: 'hide',
      labelInProgress: intl.formatMessage({ defaultMessage: 'Hiding...' }),
      labelSuccess: intl.formatMessage({ defaultMessage: 'Hidden' }),
      labelFailed: intl.formatMessage({ defaultMessage: 'Failed' }),
      handleClick: async () => await updateTrack(track.ID, { hidden: true })
    });
  }

  // This check means this CTA is available to both Admins and PLP users
  // while currently duplicative this check is left in to indicate that such a check should be added for each CTA added to this hook since some will be admin-only
  if (!track.private && (isAdmin || isPLP)) {
    linksConfig.push({
      label: intl.formatMessage({ defaultMessage: 'Add as new trail' }),
      id: 'add-as-new-trail',
      handleClick() {
        window.open(`/trail/new?recording=${track.ID}`, '_blank');
      }
    });
  }
  return linksConfig;
};

export default useAdminTrackLinks;
